import React from "react";

import { FpsView } from "react-fps";

import SwipeDecision from "../../components/Elements/SwipeDecision";
import VideoModal from "../../components/VideoModal";

import {
	isMobile,
	isTablet,
} from "../../hooks/isMobile";

import { getCaseVideo } from "../../data/cases/getCaseVideoHelper";

import styles from "../Solutions.module.css";

const SolutionsUtilityLayer = ({
	cases,

	activeSlide,
	activeVideo,
	autoPlay,
	isCurrentlyHovered,

	scrollDirectionRef,

	curViewModeIsVertical,
	initialViewVertical,

	mobileSwipeDecisionOverlayRef,
	videoModalRef,

	isOfflineMode,

	changeCursorState,
	handleVideoCloseRequest,
	handleVideoChromeVisibilityChange,
}) => {
	const caseItems =
		cases?.[0] ?? [];

	const activeCase =
		caseItems?.[
			activeSlide
		];

	const showMobileSwipe =
		isMobile ||
		(isTablet &&
			initialViewVertical);

	const showRotateScreen =
		!curViewModeIsVertical &&
		(
			isMobile ||
			(
				isTablet &&
				initialViewVertical
			)
		);

	return (
		<>
			{true ? null : (
				<div
					className={`debug-overlay ${styles.debugOverlay}`}
				>
					<FpsView />

					<div className="debug-txt">
						<div className="debug-item">
							{`autoPlay ${autoPlay}`}
						</div>

						<div className="debug-item">
							{`activeVideo ${activeVideo}`}
						</div>

						<div className="debug-item">
							{`isCurrentlyHovered ${isCurrentlyHovered}`}
						</div>

						<div className="debug-item">
							{`scrollDirection.current ${scrollDirectionRef.current}`}
						</div>
					</div>
				</div>
			)}

			<div
				className={`rotate-screen-wrapper ${styles.rotateScreen}`}
				style={{
					display:
						showRotateScreen
							? null
							: "none",
				}}
			>
				<div className="rotate-phone-icon" />

				<div className="rotate-phone-text">
					Rotate your Device
				</div>
			</div>

			{showMobileSwipe ? (
				<SwipeDecision
					ref={
						mobileSwipeDecisionOverlayRef
					}
					leftImage={
						caseItems?.[
							activeSlide -
								1
						]?.[
							"poster-portrait-900p"
						] ??
						null
					}
					rightImage={
						caseItems?.[
							activeSlide +
								1
						]?.[
							"poster-portrait-900p"
						] ??
						null
					}
				/>
			) : null}

			<VideoModal
				src={getCaseVideo(
					activeCase?.shorthand,

					"film",

					isOfflineMode
						? "2160p"
						: "1080p",
				)}
				subtrack={
					activeCase?.[
						"film-sub"
					]?.length >
					0 ? (
						<track
							kind="subtitles"
							label="English subtitles"
							src={`/img/cases/${
								activeCase
									?.shorthand
							}/subs/${
								activeCase?.[
									"film-sub"
								]
							}.vtt`}
							srcLang="en"
						/>
					) : null
				}
				changeCursorState={
					changeCursorState
				}
				onRequestClose={
					handleVideoCloseRequest
				}
				onChromeVisibilityChange={
					handleVideoChromeVisibilityChange
				}
				ref={
					videoModalRef
				}
			/>
		</>
	);
};

export default React.memo(
	SolutionsUtilityLayer,
);